/* eslint-disable */
import { getCalendar, getCalendarOrder, getCalendarLives } from '../../api/calendar';
import * as C from './constants';

export function loadCalendar() {
    return {
        type: 'PROMISE',
        actions: [
            C.START_LOAD_CALENDAR,
            C.FINISH_LOAD_CALENDAR,
            C.ERROR_LOAD_CALENDAR
        ],
        promise: getCalendar()
    };
}

export function loadCalendarOrder(ids) {
    return {
        type: 'PROMISE',
        actions: [
            C.START_LOAD_CHAMPIONATS,
            C.FINISH_LOAD_CHAMPIONATS,
            C.ERROR_LOAD_CHAMPIONATS
        ],
        promise: getCalendarOrder(ids)
    };
}


export function loadCalendarLives() {
    return {
        type: 'PROMISE',
        actions: [
            C.START_LOAD_LIVES,
            C.FINISH_LOAD_LIVES,
            C.ERROR_LOAD_LIVES
        ],
        promise: getCalendarLives()
    };
}



// WEBPACK FOOTER //
// ./src/models/calendar/actions.js